import { IMessageTypeBubble } from "../MessagePanel";

const NormalBubble = (props: IMessageTypeBubble) => {
  return <>{props.children}</>;
};

export default NormalBubble;
